import React from 'react'

interface IconProps {
  color?: string
  size?: number
  className?: string
  style?: React.CSSProperties
}

export const Bell: React.FC<IconProps> = ({
  color = '#FFFFFF',
  size = 32,
  className,
  style,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    className={className}
    style={style}
    {...rest}
  >
    <path
      d="M19.7696 24.3557L24.7409 24.3558C26.3658 24.3558 27.4829 22.5833 26.7915 21.1021L26.7834 21.0847L26.7817 21.0812L25.1998 17.8754V13.2666C25.1998 8.01131 20.8228 3.76074 15.5569 4.01047C10.5945 4.24589 6.80004 8.53828 6.80004 13.4979V17.8754L5.2181 21.0812L5.21643 21.0847L5.20838 21.1021C4.51743 22.5828 5.63285 24.3558 7.25776 24.3558L12.23 24.3557C12.3122 26.3722 13.9787 28 15.9998 28C18.0209 28 19.6874 26.3722 19.7696 24.3557ZM7.13439 21.9941L8.80874 18.6008L8.91911 18.1257H8.76406V13.4979C8.76406 9.54963 11.7666 6.17041 15.649 5.98621C19.8217 5.78838 23.2358 9.11346 23.2358 13.2666V18.1257L23.0807 18.1256C23.0806 18.2905 23.1183 18.4532 23.1911 18.6009L24.8743 22.0132C24.911 22.0933 24.898 22.1422 24.8835 22.1652C24.8688 22.1885 24.8297 22.2213 24.7409 22.2213H7.25776C7.16884 22.2213 7.13031 22.1885 7.11592 22.1656C7.10146 22.1426 7.08844 22.0932 7.12622 22.0117L7.13439 21.9941ZM15.9998 25.8655C16.8713 25.8655 17.5704 25.2109 17.6468 24.3557H15.9998H14.3528C14.4292 25.2109 15.1283 25.8655 15.9998 25.8655Z"
      fill={color}
      fillRule="evenodd"
      clipRule="evenodd"
    />
    <path
      d="M8.80874 18.6008L7.13439 21.9941L7.12622 22.0117C7.08844 22.0932 7.10146 22.1426 7.11592 22.1656C7.13031 22.1885 7.16884 22.2213 7.25776 22.2213H24.7409C24.8297 22.2213 24.8688 22.1885 24.8835 22.1652C24.898 22.1422 24.911 22.0933 24.8743 22.0132L23.1911 18.6009C23.1183 18.4532 23.0806 18.2905 23.0807 18.1256M8.80874 18.6008C8.88146 18.4531 8.91923 18.2905 8.91911 18.1257M8.80874 18.6008L8.91911 18.1257M23.0807 18.1256L23.2358 18.1257V13.2666C23.2358 9.11346 19.8217 5.78838 15.649 5.98621C11.7666 6.17041 8.76406 9.54963 8.76406 13.4979V18.1257H8.91911M23.0807 18.1256V13.2666C23.0807 9.20207 19.7401 5.94862 15.6562 6.14229C11.8626 6.32222 8.91911 9.62689 8.91911 13.4979V18.1257M15.5569 4.01047C20.8228 3.76074 25.1998 8.01131 25.1998 13.2666V17.8754L26.7817 21.0812L26.7834 21.0847L26.7915 21.1021C27.4829 22.5833 26.3658 24.3558 24.7409 24.3558L19.7696 24.3557C19.6874 26.3722 18.0209 28 15.9998 28C13.9787 28 12.3122 26.3722 12.23 24.3557L7.25776 24.3558C5.63285 24.3558 4.51743 22.5828 5.20838 21.1021L5.21643 21.0847L5.2181 21.0812L6.80004 17.8754V13.4979C6.80004 8.53828 10.5945 4.24589 15.5569 4.01047ZM15.5569 4.01047L15.5642 4.16645M17.6468 24.3557C17.5704 25.2109 16.8713 25.8655 15.9998 25.8655C15.1283 25.8655 14.4292 25.2109 14.3528 24.3557H15.9998H17.6468Z"
      stroke={color}
    />
  </svg>
)
